import React, { FC, useEffect, useState } from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectActiveRestaurantTimezone } from '../../selectors/restaurant';

const formatTime = (timezone: string) =>
  new Date().toLocaleString('en-US', {
    timeZone: timezone,
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
  });

export const LocalTimeIndicator: FC = () => {
  const timezone = useAppSelector(selectActiveRestaurantTimezone);
  const [now, setNow] = useState(() => (timezone ? formatTime(timezone) : ''));

  useEffect(() => {
    if (!timezone) return;
    setNow(formatTime(timezone));
    const id = setInterval(() => setNow(formatTime(timezone)), 60_000);
    return () => clearInterval(id);
  }, [timezone]);

  if (!timezone) return null;
  return <div>{now}</div>;
};
